/**************************************************
 * Nombre:       Home_Puedo_Ayudarte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Sola_Creacion from "../../Tarjetas/Tarjeta_Sola_Creacion";
import Tarjeta_Sola_Estrategia from "../../Tarjetas/Tarjeta_Sola_Estrategia";
import Tarjeta_Sola_Herramientas from "../../Tarjetas/Tarjeta_Sola_Herramientas";
import Tarjeta_Sola_Asesoria from "../../Tarjetas/Tarjeta_Sola_Asesoria";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Puedo_Ayudarte = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                    <Typography sx={{fontSize: 30, fontWeight: 800}}>¿Cómo puedo ayudarte?</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} justifyContent={'center'} sx={{mt: 2}}>
                    <Typography sx={{fontWeight: 400, fontSize: 20, textAlign: 'center'}}>Empecé desde cero y <span
                        style={{fontWeight: 700}}> desarrollé un método propio</span> para lograr <span
                        style={{fontWeight: 700}}>mejores resultados. </span> Ahora,
                        me apasiona compartir ese conocimiento y ayudar a otros a crecer.</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 2 : 6}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container item size={{xs: 12, sm: 6, md: 6}} sx={{px: 10, pt: sCell ? 8 : 10}}>
                            <Tarjeta_Sola_Creacion/>
                        </Grid>

                        <Grid container item size={{xs: 12, sm: 6, md: 6}} sx={{px: 10, pt: sCell ? 8 : 10}}>
                            <Tarjeta_Sola_Estrategia/>
                        </Grid>

                        <Grid container item size={{xs: 12, sm: 6, md: 6}} sx={{px: 10, pt: sCell ? 8 : 10}}>
                            <Tarjeta_Sola_Herramientas/>
                        </Grid>

                        <Grid container item size={{xs: 12, sm: 6, md: 6}} sx={{px: 10, pt: sCell ? 8 : 10}}>
                            <Tarjeta_Sola_Asesoria/>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Puedo_Ayudarte

